// extracted by mini-css-extract-plugin
export default {"banks":"Banks-module__banks--DCidp","banks__title":"Banks-module__banks__title--htoDO"};